// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".broker[data-v-147cf6ae],.broker-select[data-v-147cf6ae]{display:inline-block}.broker-select[data-v-147cf6ae]{max-width:180px}.broker-info[data-v-147cf6ae]{align-items:center;border-bottom:1px solid #ebebeb;display:flex;flex-direction:column;justify-content:center;padding-bottom:10px}.broker .broker-icon[data-v-147cf6ae]{cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
